import React, { createContext, useContext, useState, ReactNode } from 'react';
import { FeedbackModal } from '../../components/VideoTasksPage/FeedbackModal';

export type FeedbackType = 'success' | 'warning' | 'error';

export interface ModalContextType {
    showFeedback: (message: string, type?: FeedbackType, title?: string) => void;
    hideFeedback: () => void;
}

interface FeedbackState {
    isOpen: boolean;
    message: string;
    type: FeedbackType;
    title?: string;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [feedbackState, setFeedbackState] = useState<FeedbackState>({
        isOpen: false,
        message: '',
        type: 'success',
        title: undefined
    });

    const showFeedback = (message: string, type: FeedbackType = 'success', title?: string) => {
        setFeedbackState({
            isOpen: true,
            message,
            type,
            title
        });
    };

    const hideFeedback = () => {
        setFeedbackState(prev => ({ ...prev, isOpen: false }));
    };

    return (
        <ModalContext.Provider value={{ showFeedback, hideFeedback }}>
            {children}
            <FeedbackModal
                isOpen={feedbackState.isOpen}
                onClose={hideFeedback}
                message={feedbackState.message}
                type={feedbackState.type}
                title={feedbackState.title}
            />
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
}; 